// extracted by mini-css-extract-plugin
export var copyIcon = "_t0-2";
export var discountCard = "_t0-0";
export var discountCode = "_t0-3";
export var discountContent = "_t0-1";
export var loadingCard = "_t0-4";